<div class="wrapper">
  <h2 class="tac">{{'CERTIFICAR.FORALL.SELECCIONE' | translate}}</h2>
  <div>
    <mat-form-field appearance="outline" fxFlex>
      <mat-label>{{'CERTIFICAR.FORALL.PLACEHOLDER' | translate}}</mat-label>
      <mat-select #selectSector (selectionChange)="cambiaIdioma($event);">
        <mat-option *ngFor="let idioma of idiomasAdicionales; let i = index;" [value]="idioma">
          {{'NOMBREIDIOMAS.'+idioma.nombreIdioma | translate}}
        </mat-option>
      </mat-select>
      <mat-icon matSuffix class="secondary-text">language</mat-icon>
    </mat-form-field>
  </div>

  <ng-container *ngIf="cargando; else practicasCargadas">
    <div fxLayout="column" class="p-20" fxLayoutAlign="space-between center" >
      <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
      <h1>{{'CERTIFICAR.ADICIONALES.PREVIEW.LOADING' | translate}}</h1>
    </div>
  </ng-container>

  <ng-template #practicasCargadas>
    <ng-container *ngIf="nombreIdioma && seccionesDemo[0].questions.length > 0; else sinTraducciones">
      <ng-container *ngFor="let practica of seccionesDemo[0].questions; let i = index; last as last">
        <h3 *ngIf="i % 2 == 0">Práctica {{numerosMapeados[i]}}</h3>
        <div fxLayout="column" fxLayoutAlign="start stretch">
          <ng-container *ngFor="let langPractica of practica.questionLanguage;">
            <ng-container *ngIf="langPractica.lang == nombreIdioma">
              <label class="p-20">{{langPractica.question}} <code *ngIf="i % 2 == 0">{{langPractica.description4all}}</code> </label>
            </ng-container>
          </ng-container>
          <mat-radio-group fxLayout="column" fxLayoutAlign="start stretch" [(ngModel)]="responses">
            <ng-container *ngFor="let respuesta of practica.answers;">
              <ng-container *ngFor="let langResp of respuesta.answerLanguage;">
                <ng-container *ngIf="langResp.lang == nombreIdioma">
                  <mat-radio-button disabled>{{langResp.tag}}</mat-radio-button>
                </ng-container>
              </ng-container>
            </ng-container>
          </mat-radio-group>
        </div>
        <mat-divider [inset]="false" class="mt-20" *ngIf="i % 2 == 0 && !last"></mat-divider>
        <mat-divider [inset]="false" class="mt-20 mb-40" *ngIf="i % 2 != 0 && !last"></mat-divider>
      </ng-container>
    </ng-container>
    <ng-template #sinTraducciones>
      <div *ngIf="nombreIdioma" class="p-20" fxLayout="row" fxLayoutAlign="center center">
        <mat-icon class="mr-16 secondary-text">error_outline</mat-icon>
        <div class="h2 secondary-text">{{'CERTIFICAR.ADICIONALES.PREVIEW.SINPREV' | translate}}</div>
      </div>
    </ng-template>
  </ng-template>
</div>
